import api from './api';

// ── Loja (qualquer usuário autenticado) ──────────────────────────────────────

/**
 * Lista apps disponíveis na loja (somente ativos).
 * @returns {Promise<import('../types/apps').AppExtension[]>}
 */
export const listApps = async () => {
  const { data } = await api.get('/apps');
  return data;
};

// ── Super admin ──────────────────────────────────────────────────────────────

/**
 * Lista todos os apps (incluindo inativos). Requer super admin.
 * @returns {Promise<import('../types/apps').AppExtension[]>}
 */
export const listAllApps = async () => {
  const { data } = await api.get('/apps/all');
  return data;
};

/**
 * Atualiza campos de um app. Requer super admin.
 * @param {string} appId
 * @param {{ name?: string, description?: string, amount?: string, recurrence?: string, isActive?: boolean }} payload
 * @returns {Promise<import('../types/apps').AppExtension>}
 */
export const updateApp = async (appId, payload) => {
  const { data } = await api.put(`/apps/${appId}`, payload);
  return data;
};

// ── Apps da empresa (admin da empresa) ───────────────────────────────────────

/**
 * Lista apps ativos de uma empresa.
 * @param {string} companyId
 * @returns {Promise<import('../types/apps').CompanyApp[]>}
 */
export const listCompanyApps = async (companyId) => {
  const { data } = await api.get(`/companies/${companyId}/apps`);
  return data;
};

/**
 * Ativa um app para uma empresa.
 * @param {string} companyId
 * @param {string} appId
 * @returns {Promise<import('../types/apps').CompanyApp>}
 */
export const activateCompanyApp = async (companyId, appId) => {
  const { data } = await api.post(`/companies/${companyId}/apps`, { appId });
  return data;
};

/**
 * Regenera / recupera objeto `payment` (link de cobrança) para um app já solicitado.
 * Corpo vazio. Retorno: mesmo formato de `payment` no POST de ativação.
 * @param {string} companyId
 * @param {string|number} appId — id do app na loja (mesmo usado no POST ativar)
 * @returns {Promise<Record<string, unknown>>}
 */
export const prepareCompanyAppPayment = async (companyId, appId) => {
  const { data } = await api.post(`/companies/${companyId}/apps/${appId}/prepare-payment`, {});
  return data;
};

/**
 * Cancela/desativa um app de uma empresa.
 * @param {string} companyId
 * @param {string} appId
 */
export const cancelCompanyApp = async (companyId, appId) => {
  await api.delete(`/companies/${companyId}/apps/${appId}`);
};
